import React from "react";
import { Link as RouterLink } from 'react-router-dom';
import { Container, Row, Col, Button } from "reactstrap";

const rowClass = {
  marginTop: '60px',
};
const unauthText = {
  fontWeight: 200,
  color: 'darkgray'
};
const unauthImage = {
  maxWidth: '50%',
  height:'auto'
};
const unauthButton = {
  backgroundColor: 'white',
  borderColor: '#3f51b5',
  color:'#3f51b5',
  marginTop: '15px'
};

const Error401 = props => {
  return (
    <>
      <div className="main-content">
        <div className="header py-7 py-lg-8 ">
          <Container>
            <div className="header-body text-center mb-7">
              <Row className="justify-content-center" style={rowClass}>
                <Col>
                  <h1>Error 401: Unauthorized Access</h1>
                  <p className="text-lead" style={unauthText}>
                      You are not authorized to access this page.
                  </p>
                  <img
                    alt="Under development"
                    src={require("assets/img/brand/undraw_authentication_fsn5.svg")}
                    style={unauthImage}
                  />
                  <div>
                    <Button
                      color="primary"
                      tag={RouterLink}
                      exact
                      to="/auth/login"
                      variant="outlined"
                      style={unauthButton}
                    >
                      BACK TO HOME
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </div>
      </div>
    </>
  );
}

export default Error401;
